// extracted by mini-css-extract-plugin
export default {"bgDark":"Footer_bgDark__oGv7f","m20":"Footer_m20__InI1t","container":"Footer_container__iICw7"};